import React from "react"
export function Unlock(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10.543 1a4.434 4.434 0 00-4.426 4.201l-.006.236h1.773a2.66 2.66 0 012.659-2.662 2.66 2.66 0 012.653 2.48l.006.182V7.6l-8.02.001C4.529 7.601 4 8.131 4 8.784v8.283c0 .653.53 1.183 1.182 1.183h10.636c.653 0 1.182-.53 1.182-1.183V8.784c0-.653-.53-1.183-1.182-1.183l-.842-.001-.002-2.163A4.434 4.434 0 0010.543 1zm-4.77 8.376h9.454v7.1H5.773v-7.1zm4.77 1.775a1.774 1.774 0 10.002 3.552 1.774 1.774 0 00-.002-3.552z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__unlock"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
